import {Injectable} from '@angular/core';
import {Actions} from '@ngrx/effects';
// Payload Types
import {BaseStateV2} from '../../core/base.state';
import {Service} from './service';
import {CoreStore} from '../../core/core.store';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {Observable} from 'rxjs';

export const FEATURE_NAME     = 'UI_LOADER';
export const RESOURCE: string = 'loader';
export const FeatureActions   = new CoreStore.Actions(FEATURE_NAME);

// Effects

@Injectable()
export class Effects {

    private _coreEffectsOptions: CoreStore.EffectsOptions = {
        FEATURE_NAME: FEATURE_NAME,
        Actions: new CoreStore.Actions(FEATURE_NAME),
        featureService: this._svc,
        actions$: this.actions$
    };

    /*
    @Effect()
    Load$ = CoreStore.Effects.Load(this._coreEffectsOptions,
        () => RESOURCE);

    @Effect()
    ActionSuccess$ = CoreStore.Effects.ActionSuccess(this._coreEffectsOptions);

    @Effect()
    ActionFailure$ = CoreStore.Effects.ActionFailure(this._coreEffectsOptions);

    @Effect()
    SuccessReset$ = CoreStore.Effects.SuccessReset(this._coreEffectsOptions);
    */

    constructor( protected actions$: Actions<any>,  protected _svc: Service ) {}
}

interface IState extends CoreStore.State {
    isLoading: boolean;
}

const initialState: IState = {
    ...CoreStore.initialState,
    isLoading: false
};

export function reducer(state = initialState, action: any): any {
    return CoreStore.reducer(state, action, FeatureActions)
}

const selectState = createFeatureSelector<IState>(FEATURE_NAME);

export const selectors = {
    ...CoreStore.selectors(FEATURE_NAME),
    isLoading: createSelector(selectState, (state: IState) => state.isLoading)
};

@Injectable()
export class State extends BaseStateV2 {

    FEATURE_NAME: string = FEATURE_NAME;
    FeatureActions: CoreStore.Actions = FeatureActions;
    _selectors = selectors;

    get isLoading(): Observable<boolean> {
        return this._store
            .select(selectors.isLoading)
    }

    set loading(isLoading: boolean) {
        this._store.dispatch(new FeatureActions.Set({ isLoading: isLoading }))
    }

}

